module.exports = __webpack_public_path__ + "media/images/design/images/icons/x-twitter-white-1092570c039452d90551d328e0652bc9.png";